// Centralizes the face-not-found violation budget math so the modal warning text
// (NoFaceModal.jsx), the resume-vs-redirect decision (ImageProctoring.jsx), and the actual
// abort decision (Test.jsx) can't silently diverge if the boundary condition ever changes -
// previously this formula was duplicated verbatim across all three files.
//
// examDetail[0].imageproctoringcount is the admin-configured violation limit (must not be
// mutated after load - see saveToMongoFunction.js); faceNotFoundCount is the cumulative
// count of face-not-found violations so far this exam.

export const getFaceNotFoundRemaining = (examDetail, faceNotFoundCount) =>
  examDetail[0].imageproctoringcount - faceNotFoundCount;

export const isFaceNotFoundBudgetExceeded = (examDetail, faceNotFoundCount) =>
  getFaceNotFoundRemaining(examDetail, faceNotFoundCount) < 0;

export const isFaceNotFoundLastWarning = (examDetail, faceNotFoundCount) =>
  getFaceNotFoundRemaining(examDetail, faceNotFoundCount) === 0;
